document.addEventListener('DOMContentLoaded',()=>{const toggle=document.querySelector('.menu-toggle'),menu=document.getElementById('MobileMenu');if(toggle&&menu){toggle.addEventListener('click',()=>{const open=toggle.getAttribute('aria-expanded')==='true';toggle.setAttribute('aria-expanded',String(!open));menu.hidden=open;});}});
document.addEventListener('DOMContentLoaded',()=>{
  const root=document.querySelector('[data-chrome-product]');
  if(!root)return;
  const gallery=root.querySelector('.detail-gallery');
  const slides=[...root.querySelectorAll('.detail-image')];
  const counter=root.querySelector('.gallery-count');
  const select=root.querySelector('[data-variant-select]');
  const variantsScript=root.querySelector('[data-variants-json]');
  const variants=variantsScript?JSON.parse(variantsScript.textContent):[];
  const optionButtons=[...root.querySelectorAll('[data-option-button]')];
  const price=root.querySelector('[data-product-price]');
  const stickyPrice=document.querySelector('[data-sticky-price]');
  const submit=root.querySelector('[data-product-submit]');
  const stickyBuy=document.querySelector('[data-sticky-buy]');

  function goToImage(index){if(!gallery||!slides[index])return;gallery.scrollTo({left:slides[index].offsetLeft-slides[0].offsetLeft,behavior:'smooth'});}
  function updateCounter(){if(!gallery||!counter||!slides.length)return;const index=Math.min(slides.length-1,Math.max(0,Math.round(gallery.scrollLeft/(gallery.clientWidth||1))));counter.textContent=`${index+1} / ${slides.length}`;}
  function renderPrice(variant){if(!price||!variant)return;price.textContent=variant.price||'';if(variant.compare_price){const s=document.createElement('s');s.textContent=variant.compare_price;price.append(' ',s);}if(stickyPrice)stickyPrice.textContent=variant.price||'';}
  function renderAvailability(variant){if(!variant||!submit)return;submit.disabled=!variant.available;submit.textContent=variant.available?'ADD TO BAG ↗':'SOLD OUT';if(stickyBuy){stickyBuy.disabled=!variant.available;stickyBuy.textContent=variant.available?'ADD TO BAG ↗':'SOLD OUT';}}
  function syncSelectValue(variant){if(!variant||!select)return;select.value=String(variant.id);[...select.options].forEach(option=>{option.selected=option.value===String(variant.id);});}
  function syncOptionButtons(optionValues){optionButtons.forEach(button=>{const idx=Number(button.dataset.optionIndex);const active=optionValues[idx]===button.dataset.optionValue;button.classList.toggle('is-active',active);button.setAttribute('aria-pressed',String(active));});}
  function updateImageById(imageId){if(!imageId)return;const target=slides.findIndex(el=>String(el.dataset.imageId)===String(imageId));if(target>=0)goToImage(target);}
  function getCurrentSelectedOptions(){
    if(variants.length&&select){
      const current=variants.find(v=>String(v.id)===String(select.value));
      if(current?.options)return [...current.options];
    }
    const values=[];
    root.querySelectorAll('[data-option-group]').forEach(group=>{const idx=Number(group.dataset.optionIndex);const active=group.querySelector('[data-option-button].is-active');values[idx]=active?active.dataset.optionValue:'';});
    return values;
  }
  function findVariantByOptions(selectedOptions,changedIndex){
    if(!variants.length)return null;
    let exact=variants.find(v=>v.options.every((val,i)=>val===selectedOptions[i]));
    if(exact)return exact;
    if(changedIndex!==undefined&&changedIndex!==null){
      const changedValue=selectedOptions[changedIndex];
      let availableMatch=variants.find(v=>v.available&&v.options[changedIndex]===changedValue);
      if(availableMatch)return availableMatch;
      let anyMatch=variants.find(v=>v.options[changedIndex]===changedValue);
      if(anyMatch)return anyMatch;
    }
    return variants.find(v=>v.available)||variants[0]||null;
  }
  function applyVariant(variant,{updateButtons=true,updateImage=true}={}){
    if(!variant)return;
    renderPrice(variant);
    renderAvailability(variant);
    syncSelectValue(variant);
    if(updateButtons&&variant.options)syncOptionButtons(variant.options);
    if(updateImage&&variant.image_id)updateImageById(variant.image_id);
  }

  gallery?.addEventListener('scroll',updateCounter,{passive:true});
  root.querySelector('.gallery-prev')?.addEventListener('click',()=>{const i=Math.round(gallery.scrollLeft/(gallery.clientWidth||1));goToImage(Math.max(0,i-1));});
  root.querySelector('.gallery-next')?.addEventListener('click',()=>{const i=Math.round(gallery.scrollLeft/(gallery.clientWidth||1));goToImage(Math.min(slides.length-1,i+1));});

  select?.addEventListener('change',()=>{
    if(variants.length){
      const variant=variants.find(v=>String(v.id)===String(select.value));
      if(variant)applyVariant(variant,{updateButtons:true,updateImage:true});
      return;
    }
    const selected=select.selectedOptions[0];if(!selected)return;
    const variant={price:selected.dataset.price||'',compare_price:selected.dataset.comparePrice||null,available:selected.dataset.available==='true',image_id:selected.dataset.imageId||null,id:selected.value};
    applyVariant(variant,{updateButtons:false,updateImage:true});
  });

  optionButtons.forEach(button=>button.addEventListener('click',()=>{
    const optionIndex=Number(button.dataset.optionIndex);
    const selectedOptions=getCurrentSelectedOptions();
    selectedOptions[optionIndex]=button.dataset.optionValue;
    const variant=findVariantByOptions(selectedOptions,optionIndex);
    if(variant)applyVariant(variant,{updateButtons:true,updateImage:true});
    else {button.classList.add('is-active');button.setAttribute('aria-pressed','true');}
  }));

  stickyBuy?.addEventListener('click',()=>{
    if(stickyBuy.disabled)return;
    const form=root.querySelector('.chrome-product-form');
    if(!form)return;
    if(form.reportValidity()){
      if(form.requestSubmit)form.requestSubmit(submit);else submit.click();
    }
  });

  if(variants.length){
    const initial=variants.find(v=>String(v.id)===String(select?.value))||variants[0];
    applyVariant(initial,{updateButtons:true,updateImage:false});
  }
  updateCounter();
});
